<form [formGroup]="form" (ngSubmit)="formSubmitHandler()">
  <db-modal
    [title]="titleText()"
    width="lg"
    primaryLabel="Export"
    i18n-primaryLabel="@@common|export"
    secondaryLabel="Cancel"
    i18n-secondaryLabel="@@common|cancel"
    (primaryAction)="formSubmitHandler()"
    (secondaryAction)="cancelHandler()"
    (closeDialog)="cancelHandler()"
    [isSubmitting]="isSubmitting()"
    [disabledPrimaryAction]="form.invalid"
  >
    <div class="flex flex-col gap-4xl">
      <div>
        <db-radio-button
          name="exportType"
          [label]="getExportAllLabel()"
          [value]="exportRangeType.ALL"
          formControlName="exportType"
          [inputId]="'exportType1Option'"
          (ngModelChange)="toggleDateRangeActivity()"
        ></db-radio-button>
      </div>

      <div>
        <db-radio-button
          name="exportType"
          [label]="getExportTimeframeLabel()"
          [value]="exportRangeType.TIMEFRAME"
          formControlName="exportType"
          [inputId]="'exportType2Option'"
          (ngModelChange)="toggleDateRangeActivity()"
        ></db-radio-button>
      </div>

      <div class="flex gap-3xl">
        <db-date-picker-input
          class="flex-1"
          formControlName="startDate"
          label="Start Date"
          i18n-label="@@common|start-date"
          [errorListDictionary]="datesErrorDictionary"
          placeholder="Select a date"
          i18n-placeholder="@@common|select-a-date"
        >
        </db-date-picker-input>
        <db-date-picker-input
          class="flex-1"
          formControlName="endDate"
          label="End Date"
          i18n-label="@@common|end-date"
          [errorListDictionary]="datesErrorDictionary"
          placeholder="Select a date"
          i18n-placeholder="@@common|select-a-date"
        >
        </db-date-picker-input>
      </div>
    </div>
  </db-modal>
</form>
